import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';

const Dropdown = ({
  children,
  trigger,
  position = 'bottom-right',
  className = '',
  disabled = false,
  closeOnClick = true,
  items = [],
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const handleTriggerClick = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    }
    if (closeOnClick) {
      setIsOpen(false);
    }
  };

  const getPositionClasses = () => {
    const positions = {
      'bottom-left': 'top-full left-0 mt-2',
      'bottom-right': 'top-full right-0 mt-2',
      'top-left': 'bottom-full left-0 mb-2',
      'top-right': 'bottom-full right-0 mb-2',
      'bottom-center': 'top-full left-1/2 transform -translate-x-1/2 mt-2',
      'top-center': 'bottom-full left-1/2 transform -translate-x-1/2 mb-2'
    };
    return positions[position] || positions['bottom-right'];
  };

  return (
    <div className={`relative inline-block ${className}`} {...props}>
      <div
        ref={triggerRef}
        onClick={handleTriggerClick}
        className={`cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {trigger}
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={`absolute z-50 ${getPositionClasses()}`}
        >
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-48 max-w-xs">
            {children || items.map((item, index) => (
              <button
                key={index}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                onClick={() => handleItemClick(item)}
              >
                {item.icon && <span>{item.icon}</span>}
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
